/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Etaf_Link_Contact_InvalidInputs */

const en_error_etaf_link_contact_invalid = /** @type {(inputs: Error_Etaf_Link_Contact_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The link cannot be sent to this contact:`)
};

/**
* | output |
* | --- |
* | "The link cannot be sent to this contact:" |
*
* @param {Error_Etaf_Link_Contact_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_etaf_link_contact_invalid = /** @type {((inputs?: Error_Etaf_Link_Contact_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Etaf_Link_Contact_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_etaf_link_contact_invalid(inputs)
});